import React from "react";
import styled from "styled-components";
import {
    ActivateFeatureButton,
    Button,
    CardTableRows,
    CardTableSelectAllControl,
    CardTableShell,
    CardTableToolbar,
    FlexContainer,
    LottieAnimation,
    PortalEmptyState,
    PortalSelect,
    PortalTableActions,
    PortalTableControls,
} from "src/components";
import Checkbox from "src/scenes/EmployeeList/components/Checkbox";
import AdvertisingContent from "./AdvertisingContent";
import PurpleLottieJson from "./../assets/purple-lottie.json";
import { FILTER_BY, AUDIENCE } from "../Advertising";
import pluralize from "pluralize";
import { customNames, capitalizeString } from "src/utils/helpers";

const UpperButtons = styled(Button)`
    border-radius: 8px !important;
    border: ${p => p.border || "none"};
    height: 42px;
    color: ${p => p.color || "var(--calendar-action-primary-text, #fff)"};
    background-color: ${p => p.backgroundColor || "var(--calendar-action-primary-bg, #5B6EF5)"};
    box-sizing: border-box;
    font-size: 0.875rem;
    font-weight: 700;
    padding: ${p => p.padding};
    display: flex;
    align-items: center;
    margin-right: 0.625em;
`;

const DescriptionLabel = styled.div`
    color: var(--calendar-text, #171A22);
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
`;

const InputSelector = styled(PortalSelect)`
    width: 12.5rem;
`;

const AdvertisingTable = ({
    advertisementsArray,
    handleShowDeleteDialog,
    checkedAds,
    handleCheckboxChange,
    handleCheckAllAds,
    checkAllAds,
    isFetching,
    filterByOption,
    audienceOption,
    handleFilterChange,
    handleAudienceChange,
    handleShowAdForm,
    handleEditAd
}) => {
    return (
        <FlexContainer>
            <CardTableShell maxWidth="98.625rem" minHeight="924px">
                <CardTableToolbar>
                    <PortalTableControls>
                        <CardTableSelectAllControl>
                            <Checkbox
                                key="selectAll"
                                readOnly={false}
                                checked={checkAllAds}
                                onClick={ () => handleCheckAllAds(advertisementsArray) }
                            />
                        </CardTableSelectAllControl>
                        <InputSelector value={filterByOption} onChange={handleFilterChange}>
                            <option value={FILTER_BY.ACTIVE_ADS}>Active Ads</option>
                            <option value={FILTER_BY.SCHEDULED_ADS}>Scheduled Ads</option>
                            <option value={FILTER_BY.COMPLETED_ADS}>Completed Ads</option>
                        </InputSelector>
                        <InputSelector value={audienceOption} onChange={handleAudienceChange}>
                            <option value={AUDIENCE.EMPLOYEE}>{capitalizeString(pluralize(customNames.employees))}</option>
                            <option value={AUDIENCE.CLIENT}>{capitalizeString(pluralize(customNames.clients))}</option>
                            <option value={AUDIENCE.EMPLOYEES_CLIENTS}>{capitalizeString(pluralize(customNames.employees))} & {capitalizeString(pluralize(customNames.clients))}</option>
                        </InputSelector>
                        { checkedAds.length > 0 &&
                            <UpperButtons backgroundColor="#ff7171" padding="0.625rem 0.938rem 0.625rem" onClick={() => handleShowDeleteDialog()}>Delete Selected Ads</UpperButtons>
                        }
                    </PortalTableControls>
                    <PortalTableActions>
                        <ActivateFeatureButton width="13.125rem" onClick={() => handleShowAdForm() }>Create New Ad</ActivateFeatureButton>
                    </PortalTableActions>
                </CardTableToolbar>

                <CardTableRows maxHeight="none" minHeight="52rem">
                { 
                    isFetching && 
                    <FlexContainer 
                        justifyContent="center"
                        alignItems="center"
                        style={{ height: "100%" }}>
                        <PurpleLoadingIndicator/>
                    </FlexContainer>
                }

                { 
                    !isFetching && 
                    <>
                        { advertisementsArray.length === 0 && <NoAdvertisementAvailable/> }
                        { advertisementsArray.length !== 0 &&
                            <AdvertisingContent 
                                advertisingArray={advertisementsArray} 
                                checkedAds={checkedAds}
                                handleCheckboxChange={handleCheckboxChange}
                                handleEditAd={handleEditAd}
                            /> 
                        }
                    </>
                }
                </CardTableRows>
            </CardTableShell>
        </FlexContainer>
    );
};

function NoAdvertisementAvailable() {
    return (
        <PortalEmptyState minHeight="225px">
            <DescriptionLabel>There are no active ads at the moment. Once you create your first ad, it will appear here in your active ads list and be displayed across the app&apos;s features.</DescriptionLabel>
        </PortalEmptyState>
    );
}

function PurpleLoadingIndicator() {
    return (
        <FlexContainer>
            <LottieAnimation animationJsonData={PurpleLottieJson} />
        </FlexContainer>
    );
}
export default AdvertisingTable;
